import React, {Component} from 'react';
import './ResetPasswordPageComponent.less';
import ResetPasswordComponent from '../ResetPasswordComponent/ResetPasswordComponent';

class ResetPasswordPageComponent extends Component {
    render() {
        return (
            <div className="border-border-color">
                <ResetPasswordComponent lingua={this.props.lingua} updatePage={this.props.updatePage}/>
            </div>
        );
    }
}

export default ResetPasswordPageComponent;
